// Google Maps（会社概要 / English）
// 課金最適化: #map が画面に入る直前に API を読み込み、resize 時は地図を作り直さず
// setCenter / setIcon のみで追従（new google.maps.Map のたびに Map Load 課金されるため）

const THEME_URI = window.ORIGIN_THEME_URI || '';
const MARKER_URL = THEME_URI + '/assets/image/company/map-marker@2x.png';

const mapInit = (marker_latlan, center_latlan, zoom, marker_size) => {
  const options = {
    zoom: zoom || 16,
    center: marker_latlan,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true,
    type: false,
    zoomControl: true,
    scrollwheel: false,
  };
  const style = [
    { featureType: 'transit', stylers: [{ saturation: -100 }] },
    { featureType: 'administrative', stylers: [{ visibility: 'off' }] },
    { featureType: 'poi', stylers: [{ saturation: -100 }] },
    { featureType: 'water', elementType: 'labels', stylers: [{ visibility: 'off' }] },
    { featureType: 'water', stylers: [{ color: '#e9e9e9' }, { lightness: 100 }] },
    { featureType: 'road', elementType: 'labels', stylers: [{ visibility: 'off' }] },
    { featureType: 'road', stylers: [{ saturation: -100 }] },
    { featureType: 'landscape', stylers: [{ saturation: -100 }, { lightness: 10 }] },
  ];
  const map = new google.maps.Map(document.getElementById('map'), options);
  const marker = new google.maps.Marker({
    position: marker_latlan,
    icon: { url: MARKER_URL, scaledSize: marker_size },
    map,
    title: '福永紙工',
  });
  map.mapTypes.set('noText', new google.maps.StyledMapType(style, options));
  map.setMapTypeId('noText');
  if (center_latlan) map.setCenter(center_latlan);
  return { map, marker };
};

let map = null;
let marker = null;
let resizeTimer = null;
let mapApiRequested = false;

const isSp = () => window.matchMedia('(max-width:1039px)').matches;

// Maps API 読み込み完了後のコールバック（&callback=initMap）。グローバル公開が必要
window.initMap = () => {
  const marker_latlan = new google.maps.LatLng(35.689103, 139.416780);
  let created;
  if (isSp()) {
    const center = new google.maps.LatLng(35.693500, 139.416780);
    created = mapInit(marker_latlan, center, 15, new google.maps.Size(150, 75));
  } else {
    created = mapInit(marker_latlan, marker_latlan, 15, new google.maps.Size(201, 99));
  }
  map = created.map;
  marker = created.marker;
};

// resize は作り直さず setCenter / setIcon のみ（課金対象外）
const onResize = () => {
  if (!map) return;
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    if (isSp()) {
      map.setCenter(new google.maps.LatLng(35.693500, 139.416780));
      marker.setIcon({ url: MARKER_URL, scaledSize: new google.maps.Size(150, 75) });
    } else {
      map.setCenter(new google.maps.LatLng(35.689103, 139.416780));
      marker.setIcon({ url: MARKER_URL, scaledSize: new google.maps.Size(201, 99) });
    }
  }, 500);
};

// Maps API スクリプトを動的注入（1回だけ）
const loadMapApi = () => {
  if (mapApiRequested) return;
  mapApiRequested = true;
  const script = document.createElement('script');
  script.src = '//maps.googleapis.com/maps/api/js?key=AIzaSyBZkhGBXn1A6lntt96lvofNFfs7mW1zK6k&callback=initMap';
  script.async = true;
  document.head.appendChild(script);
};

document.addEventListener('DOMContentLoaded', () => {
  // #map が画面に入る直前に API を読み込む（地図まで到達しない訪問では Map Load が発生しない）
  const target = document.getElementById('map');
  if (target) {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          loadMapApi();
          observer.disconnect();
          break;
        }
      }
    }, { rootMargin: '200px' });
    observer.observe(target);
  }
  window.addEventListener('resize', onResize);
});
